import * as React from 'react';
import { ReactNode } from 'react';
import './AlternatesParts.scss';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import { goToPartDetailAltPart, partDetailUrl } from 'src/utils/navigation';



interface IAlternatePartsState {
  itemsToShow: number;
  expanded: boolean;
}

interface IAlternatePartsProps {
  altParts:any[];
  defaultAltItemsToShow:number;
}
let MAX_LENGTH_ELEMENTS = 3;
export class AlternatesParts extends React.Component<IAlternatePartsProps, IAlternatePartsState> {
  public scrollDiv: any;
  constructor(props: any) {
    super(props);
    this.state = {
      itemsToShow: this.props.defaultAltItemsToShow,
      expanded: false
    };
    this.scrollDiv = React.createRef();
    MAX_LENGTH_ELEMENTS = this.props.defaultAltItemsToShow;
  }

  private showMore = () => {
    this.state.itemsToShow === this.props.defaultAltItemsToShow
      ? this.setState({
          itemsToShow: this.props.altParts.length,
          expanded: true
        })
      : this.setState({
          itemsToShow: this.props.defaultAltItemsToShow,
          expanded: false
        });
  };

  private scrollSmoothHandler = () => {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
  };

  private goToPartDetailsFromAlt=(productNumber:any)=>{
    localStorage.setItem('isAltPart', "YES");
    goToPartDetailAltPart(productNumber);
  }

  private getStatus=(partStatus:string,specialOrderStatus:boolean)=>{
  return(
    <div className="rp-product-alter-part-box--status">
    
      {partStatus==="No Longer Available" && (
        <span className="rp-product-alter-part-box--status-container">
        <i className="rpds rpds-remove-circle" />
        <span className='status-red-text'>{i18n.t('common.noLongerAvailable')}</span>
        </span>
      )}
     {partStatus==="In Stock" && (
        <span className="rp-product-alter-part-box--status-container">
        <i className="rpds rpds-check-circle" />
        <span className='status-color-text'>{i18n.t('common.inStock')} </span>
        </span>
      )}
      {partStatus==="Backorder" && (
        <span className="rp-product-alter-part-box--status-container">
        <i className="rpds rpds-remove-circle" />
              <span className='status-red-text'>{i18n.t('myOrders.backOrder')} </span>
        </span>
      )}
      {partStatus==="notAvailable" && (
        <span className="rp-product-alter-part-box--status-container">
        <i className="rpds rpds-remove-circle" />
              <span className='status-red-text'>{i18n.t('common.notAvailable')} </span>
        </span>
      )}
      {specialOrderStatus===true && (
        <span className="rp-product-alter-part-box--status-container">
         <i className="rpds rpds-new-releases" />
              <span className='status-new-release-color-text'>{i18n.t('common.specialOrder')} </span>
        </span>
      )}
    </div> 
  )
 }

  private renderContent = () => {
   
    // return this.props.tabContents[this.props.currentTab];
    return (
      this.props.altParts.length && 
      <div className="rp-alt-part-tab--info">

      <div className="alternate-parts-container">
      { this.props.altParts.slice(0, this.state.itemsToShow).map((data: any) => (
             <div className="alternate-parts-item">
              <a className="reloadLink" onClick={e => this.goToPartDetailsFromAlt(data.productNumber)}>{data.productNumber} </a>
             
              { data.notes && data.notes!==null && data.notes!=="" &&
              <span className="alt-parts-notes">
                <span className={`rpds-error shipping-icon`} />
                <div className="rp-alt-part--notes-notification">
                {data.notes}
                </div>
              </span> 
              }
              {this.getStatus(data.state,data.specialOrder)}
              </div>
              ))
      }
      </div>
    
      <div className="rp-pick-up-tab--addresses">
      {this.props.altParts.length > MAX_LENGTH_ELEMENTS &&
            <div
              className="rp-ship-from-tab--addresses--show-more-toggle"
              onClick={this.showMore}
            >
              {this.state.expanded ? (
                <React.Fragment>
                  <div
                    className="rp-ship-from-tab--show-more-toggle"
                  >
                    <span className="rpds-remove" />
                    <span className="rp-ship-from-tab--show-more-toggle-text">
                      {i18n.t('product.showLessAlternates')}
                    </span>
                  </div>
                  
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="rp-ship-from-tab--show-more-toggle">
                    <span className="rpds-add" />
                    <span className="rp-ship-from-tab--show-more-toggle-text">
                      {i18n.t('product.showMoreAlternates')}
                    </span>
                  </div>
                </React.Fragment>
              )}
            </div>
         }
      </div>
    </div>
    );
  };

  public render() {
    return (
      <div ref={this.scrollDiv} className="rp-tabs">

        <div className="alt-part-container">
          <div className='alt-part-title'>{i18n.t('product.alternateParts')}</div>
          <div className='alt-part-content'>{this.renderContent()}</div>
        </div>
      </div>
      
    );
  }
}
